var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("Copyright © 2010-2015 sqgj.gov.cn, All Rights Reserved")]),_c('p',[_vm._v("陕西干部网络学院陕ICP备10001194号-6")]),_c('div',{staticClass:"w-1200 d-flex j-end"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/code.png"),"alt":""}}),_c('p',{staticStyle:{"color":"#fff","font-size":"16px"}},[_vm._v("官方微博")])])])])
}]

export { render, staticRenderFns }